var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-upwork",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M24.748 17.544c-1.469 0-2.847-0.623-4.099-1.636l0.304-1.435 0.011-0.056c0.276-1.524 1.132-4.080 3.785-4.080 1.989 0 3.604 1.616 3.604 3.604-0.001 1.985-1.616 3.603-3.605 3.603zM24.748 6.691c-3.385 0-6.013 2.199-7.080 5.821-1.627-2.445-2.864-5.381-3.583-7.856h-3.648v9.483c-0.003 1.875-1.521 3.395-3.396 3.397-1.873-0.003-3.391-1.524-3.393-3.397v-9.483h-3.648v9.483c0 3.885 3.16 7.071 7.041 7.071 3.884 0 7.044-3.185 7.044-7.071v-1.587c0.705 1.476 1.576 2.972 2.632 4.295l-2.231 10.497h3.729l1.617-7.613c1.417 0.905 3.047 1.479 4.915 1.479 4 0 7.252-3.269 7.252-7.267 0-4-3.252-7.252-7.252-7.252z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwork);
export default __webpack_public_path__ + "static/media/upwork.b0431b5ce8d312ffeabf0b7a9076fb72.svg";
export { ForwardRef as ReactComponent };